import { render, staticRenderFns } from "./PageAboutUs.vue?vue&type=template&id=2166d47c&"
import script from "./PageAboutUs.vue?vue&type=script&lang=js&"
export * from "./PageAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports